<template>
  <div class="label-barcode" :data-barcode="barcode?.code">
    <svg v-if="!barcodeError" id="barcode-label-svg" ref="barcodeRef" class="barcode-svg"></svg>
    <div v-else class="barcode-error has-text-danger is-size-7">Barcode could not be rendered</div>
  </div>
</template>

<script setup>
  import { ref, watchEffect } from "vue";
  import JsBarcode from "jsbarcode";
  import { getBarcodeFormat, BARCODE_CONSTANTS } from "~/label/barcode/constants";

  const props = defineProps({
    barcode: { type: Object, required: true },
  });

  const barcodeRef = ref(null);
  const barcodeError = ref(false);

  watchEffect(() => {
    barcodeError.value = false;
    if (barcodeRef.value && props.barcode?.code) {
      try {
        JsBarcode(barcodeRef.value, props.barcode.code, {
          format: getBarcodeFormat(props.barcode.type),
          displayValue: true,
          fontSize: 12,
          width: props.barcode.width || BARCODE_CONSTANTS.DEFAULT_WIDTH,
          height: props.barcode.height || BARCODE_CONSTANTS.DEFAULT_HEIGHT,
        });
      } catch (e) {
        console.warn("Barcode rendering failed:", e);
        barcodeError.value = true;
      }
    }
  });
</script>

<style lang="scss" scoped>
  .label-barcode {
    margin-top: 1rem;
    text-align: center;
  }

  .barcode-error {
    padding: 0.5rem;
    background: #fff5f5;
    border: 1px dashed #ff6b6b;
    border-radius: 4px;
  }
</style>
